import React from "react";
import '../assets/scss/custom/priorityBadge.scss';

interface PriorityBadgeProps {
  params: string;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ params }) => {
  if (!params) {
    return <span className="badge background-default">No Priority</span>;
  }

  // Normalize priority for consistent styling
  const priority = params.toLowerCase();

  // Determine the appropriate background class based on priority
  const priorityClass =
    priority === "high"
      ? "high"
      : priority === "medium"
      ? "medium"
      : priority === "low"
      ? "low"
      : "default";

  return (
    <span className={`badge bg-${priorityClass}`} style={{ fontWeight: 600 }}>
      {params}
    </span>
  );
};
